import { SVGProps } from "react";

export function RewardIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5372 12.824L11.9999 15.749L13.4849 14.2262L15.75 14.2488L13.6426 10.0638V10.0566M7.4628 12.824L6.00012 15.749L4.51512 14.2262L2.25 14.2488L4.35744 10.0638V10.0566"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4601 7.49932C14.4601 8.06956 13.9576 8.54944 13.7923 9.05956C13.6274 9.56932 13.7401 10.267 13.4176 10.7094C13.095 11.1519 12.4049 11.2494 11.9999 11.5796C11.5949 11.9097 11.25 12.5246 10.7251 12.697C10.1999 12.8694 9.60732 12.5393 9.03744 12.5393C8.46756 12.5393 7.86024 12.8619 7.35012 12.697C6.84 12.5318 6.51744 11.8942 6.075 11.5796C5.6322 11.2646 4.94244 11.1519 4.61988 10.7094C4.29732 10.2666 4.41756 9.58444 4.24512 9.05956C4.07232 8.53432 3.53988 8.06956 3.53988 7.49932C3.53988 6.92908 4.04244 6.44956 4.20732 5.93944C4.3722 5.42932 4.25988 4.732 4.58244 4.28956C4.905 3.84712 5.59512 3.74956 6.03756 3.41944C6.48 3.08932 6.75 2.47444 7.31232 2.302C7.875 2.1292 8.43012 2.45932 9 2.45932C9.56988 2.45932 10.1772 2.13676 10.6877 2.302C11.1974 2.46688 11.52 3.10444 11.9999 3.41944C12.4798 3.73444 13.1324 3.84676 13.455 4.28956C13.7776 4.73236 13.6577 5.41456 13.8301 5.93944C14.0026 6.46432 14.4601 6.92944 14.4601 7.49932ZM9 5.24932C8.40321 5.24932 7.83087 5.48639 7.40888 5.90838C6.98689 6.33037 6.74982 6.90272 6.74982 7.4995C6.74982 8.09629 6.98689 8.66863 7.40888 9.09062C7.83087 9.51261 8.40321 9.74968 9 9.74968C9.59674 9.74968 10.169 9.51263 10.591 9.09067C11.0129 8.66872 11.25 8.09642 11.25 7.49968C11.25 6.90294 11.0129 6.33065 10.591 5.90869C10.169 5.48674 9.59674 5.24932 9 5.24932Z"
        stroke="#F4A100"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
